import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { mealImage } from "../lib/millie";

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const memo = new Map();

export function useDishImage(title, description = "") {
  const [url, setUrl] = useState(memo.get(title) || null);
  useEffect(() => {
    if (!title) return;
    if (memo.has(title)) { setUrl(memo.get(title)); return; }
    let cancelled = false, tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.post("/meal-image", { title, description });
        if (cancelled) return;
        if (data.status === "ready") { memo.set(title, data.url); setUrl(data.url); return; }
        if (data.status === "rendering" && tries++ < 12) setTimeout(poll, 5000);
      } catch { /* keep stock photo */ }
    };
    poll();
    return () => { cancelled = true; };
  }, [title, description]);
  return url ? `${API_BASE}${url}` : null;
}

/* Photo of the actual dish (AI-generated once, cached). Falls back to the stock image while rendering. */
export default function DishImage({ meal, className = "", testId }) {
  const real = useDishImage(meal?.title, meal?.description);
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={testId} data-real={!!real}>
      <img src={mealImage(meal?.image_key)} alt="" aria-hidden className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${real && loaded ? "opacity-0" : "opacity-100"}`} />
      {real && <img src={real} alt={meal?.title} onLoad={() => setLoaded(true)} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`} />}
    </div>
  );
}
